module.exports = __webpack_public_path__ + "static/media/picton.4a003bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/picton.png
// module id = 48
// module chunks = 0